import React from 'react';
import ZNetwork from "./znetwork";
import {ROUTER} from "./AMCRouter";
import {ZOO} from "./zoo";
import {APP} from "./App";
import ZAPI from "./zapi";
import ZProps from "./zprops";
import ZLog from "./zlog";
import ZUtil from "./zutil";
import AMCForm from './AMCForm';
import PleaseStandBy from "./PleaseStandBy";
import ZooNothingFoundPage from "./ZooNothingFoundPage";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faSyncAlt } from '@fortawesome/free-solid-svg-icons'

export default class AMCAdmin extends React.Component {
	constructor(props) {
		super(props);
		this.state = { page: 0, view: "cache", platform: ZUtil.getPlatform(), table: "Things", sort_column: "uri", sort_order: "ASC", items: [], current_search_item_index: 0 };
		this.total_num_search_items = 0;
		this.VIRTUAL_TABLENAMES = [ "users", "members", "tokens", "services", "models" ];
	}
	componentDidMount() {
		let path = ZProps.get("path");
console.log("pathhhh=" + path);
		ZOO.expandThisPageOnly();
		ZNetwork.get("admin:tables", (err, tables) => {
			if (!err) {
				this.setState({ tables: tables, item: null });
			} else {
				this.setState({ error: "404" });
			}
		});
		if (path !== "/admin") {
			let params = path.split("/");
			let platform = params[2];
			let view = params[3];
			let table_or_servicelog_uri = params[4];
			if (view === "servicelogs") {
				table_or_servicelog_uri = params.slice(4).join("/");
			}
console.log("table_or_servicelog_uri=" + table_or_servicelog_uri);
			this.setState({ platform: platform, view: view, table: view === "servicelogs" ? null : (table_or_servicelog_uri || "Things"), item_uri: params[5], servicelog_uri:  view === "servicelogs" ? table_or_servicelog_uri : null });
			if (view === "database" || view === "cache") {
				this.load(platform, view, params[4], 0, (err) => {
					let item = params[4] && this.state.items.find( item => item.uri === params[4] );
					this.popupItemEditor(item);
				});
			} else if (view !== "settings" && view !== "users") {
				this.loadLogs(platform, view, table_or_servicelog_uri, 0, (err) => {

				});
			}
		}
	}
	componentWillUnmount() {
	}
	refreshScreen = () => {
console.log("refreshScreen");
		this.onSelectView(this.state.view);
	}
	onSelectView(view) {
		this.setState({ view: view });
console.log("onSelectView=" + view);
		this.sorted_items = null;
		if (view === "settings") {
			ROUTER.softPushRoute("/admin/" + this.state.platform + "/" + view);
			this.forceUpdate();
		} else if (view === "database" || view === "cache") {
			ROUTER.softPushRoute("/admin/" + this.state.platform + "/" + view + "/" + this.state.table);
			this.load(this.state.platform, view, this.state.table, this.state.page);
		} else {
			ROUTER.softPushRoute("/admin/" + this.state.platform + "/" + view);
			this.loadLogs(this.state.platform, view, this.state.servicelog_uri, 0);
		}
	}
	onSelectPlatform(platform) {
		this.setState({ platform: platform });
		ZAPI.setPlatform(platform);
console.log("onSelectPlatform: " + platform);
		if (this.state.view === "database" || this.state.view === "cache") {
			this.load(platform, this.state.view, this.state.table, this.state.page);
		} else {
			this.loadLogs(platform, this.state.view, this.state.servicelog_uri, 0);
		}
	}
	onSelectTable = (tablename) => {
		this.sorted_items = null;
		this.setState({ table: tablename });
		this.load(this.state.platform, this.state.view, tablename, this.state.page);
	}
	onSelectServiceLog = (uri) => {
		this.setState({ servicelog_uri: uri });
		this.loadLogs(this.state.platform, this.state.view, uri, this.state.page);
	}
	onSelectItem(item) {
		ROUTER.softPushRoute("/admin/" + this.state.platform + "/" + this.state.view + "/" + this.state.table + "/" + item.uri);
		this.sorted_items = null;
		this.popupItemEditor(item);
	}
	popupItemEditor(item) {
		if (item) {
			APP.showPopup(<AMCAdminItemPopup item={item} />);
		}
		// this.setState({ item: item });
	}
	load(platform, view, table, page, callback) {
		let PAGESIZE = 100;
console.log("load view=" + view);
		ROUTER.softPushRoute("/admin/" + platform + "/" + view + "/" + table);
		this.setState({ loading: true });
		let search_db_keyword = null;
		// search: name:value, name:>value, name:"value"
		ZNetwork.post("admin:" + view, table, { platform: platform, page: page, pagesize: PAGESIZE, search: search_db_keyword }, (err, items) => {
			if (!err) {
				this.setState({ items: items, page: page, loading: false  });
				if (callback) {
					callback();
				}
			} else {
				this.setState({ loading: false, error: true, items: [] });
			}
		});
	}
	loadLogs(platform, view, servicelog_uri, page, callback) {
		ROUTER.softPushRoute("/admin/" + platform + "/" + view + (servicelog_uri ? "/" + servicelog_uri : ""));
		ZAPI.setPlatform(platform);
		if (view === "servicelogs") {
			// list services most recently used first
			this.setState({ loading: true });
			ZNetwork.post("admin:cache", "activeservices", { page: 0, pagesize: 250 }, (err, active_service_uris) => {
				if ((active_service_uris || []).length > 0) {
					// kludge, API needs ordered set (read count and optional pop each lpush) or read list to see if new uri exists
					active_service_uris = ZUtil.uniq(active_service_uris);
					this.setState({ loading: false, servicelogs_uris: active_service_uris, servicelog_uri: servicelog_uri || active_service_uris[0] });
					this._loadLogs(platform, view, servicelog_uri, page);
				}
			});
		} else {
			this._loadLogs(platform, view, null, page);
		}
	}
	_loadLogs(platform, view, servicelog_uri, page, callback) {
		let PAGESIZE = 2000;
		this.setState({ loading: true });
console.error("_loadlogs");
		ZNetwork.post("admin:logs", null, { api: view === "apilogs", service_uri: servicelog_uri, page: 0, pagesize: PAGESIZE, platform: platform }, (err, list) => {
		//ZAPI.invoke(view, servicelog_uri, { pagesize: PAGESIZE, page: page }, (err, list) => {
			ZAPI.setPlatform(this.state.platform);
			if (err) {
				ZLog.error("AMCAdmin.loadLogs err=" + err);
			}
			// ZLog.debug(" _loadLogs list=", { list: list });
			if (list && list.message) {
				list = [list];
			}
			this.setState({ loading: false, logs: err || !list ? [{ message: "No logs found" }] : list });
		});
	}
	toggleSortOrderAndColumn(column) {
		this.setState({ sort_column: column, sort_order: this.state.sort_column !== column ? "ASC" : this.state.sort_order === "ASC" ? "DESC" : "ASC" });
	}
	onScroll(event) {
		var position = event.target.scrollLeft;
		// ZUtil.throttler("adminhscroller", this.updateHeaderLabels.bind(this), position, 50);
		if (!this.will_update_headers) {
			window.requestAnimationFrame(() => {
				this.updateHeaderLabels(position);
				this.will_update_headers = false;
			});
		}
        	this.will_update_headers = true;
	}
	onSearchLogsChange = (e) => {
		this.searchLogs(e.target.value);
	}
	searchLogs = (value) => {
console.log("onSearchLogsChange" + value);
		ZUtil.throttle("admin.logs", () => {
console.log("onSearchLogsChange set state " + value);
			this.setState({ search_logs_keyword: value });
		}, 500);
	}
	onSearchIndexChange = (delta) => {
		let newindex = this.state.current_search_item_index + delta;
		if (newindex > this.total_num_search_items) {
			newindex = 1;
		} else if (newindex < 0) {
			newindex = this.total_num_search_items;
		}
		this.setState({ current_search_item_index: newindex });
	}
	hasKeyword(str, keyword) {
		return keyword && str.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
	}
	replaceKeywordWithEmphasis(str, keyword) {
		if (keyword) {
			//let re = new RegExp(keyword,"i")
			//let index = str.indexOf(re, keyword);
			let index = str.toLowerCase().indexOf(keyword.toLowerCase());
			if (index !== -1) {
				str = <span>{str.substring(0, index)}<strong>{str.substring(index, index + keyword.length)}</strong>{str.substring(index + keyword.length)}</span>
			}
		}
		return str;
	}
	show = (stats) => {
		this.setState({ loading: true });
		let options = stats === "actionsForPeriod" || stats === "thingsForPeriod" ? { days: 30 } : null;
		ZNetwork.post("admin:stats", null, null, { which: stats, options: options }, (err, result) => {
			if (err) {
				result = [];
			}
			this.setState({ loading: false, stats: result, whichstats: stats });
		});
	}
	rebuild = (subsystem) => {
		if (subsystem === "cache" || subsystem === "db") {
			APP.areYouSure(() => { this._rebuild(subsystem) });
		} else {
			this._rebuild(subsystem);
		}
	}
	_rebuild = (subsystem) => {
		this.setState({ loading: true });
		ZNetwork.post("rebuild", null, null, { platform: this.state.platform, subsystem: subsystem }, (err, result) => {
			this.setState({ loading: false });
		});
	}
/*
	searchDB = (str) => {
		this.setState({ search_db_keyword: str });
		this.load(this.state.platform, this.state.view, this.state.table, this.state.page);
	}
*/
	render() {
		let { table, tables, stats, whichstats, items, view, platform, logs, sort_order, sort_column, loading, filter, error, search_logs_keyword, current_search_item_index, servicelogs_uris, servicelog_uri } = this.state;

		if (error) {
			return <ZooNothingFoundPage />
		}
		if (!tables || loading) {
			return <PleaseStandBy />
		}
console.log("admin table=" + table);
		let sidebar = null;
		let body = <h1 className="CENTERED_PART">None</h1>;
		if (view === "stats") {
			/////////////////////
			// STATS
			/////////////////////
			let width = 12;
			sidebar = <div>
					<ul>
					<li className={whichstats === "actions" ? "AMCAdminSideBarSelected" : ""}><a onClick={e => this.show("actions")}>actions (today)</a></li>
					<li className={whichstats === "actionsForPeriod" ? "AMCAdminSideBarSelected" : ""}><a onClick={e => this.show("actionsForPeriod")}>actions (30 days)</a></li>
					<li><a onClick={e => this.rebuild("activitymatrix")}>rebuild actions matrix</a></li>
					<li className={whichstats === "things" ? "AMCAdminSideBarSelected" : ""}><a onClick={e => this.show("things")}>things (today)</a></li>
					<li className={whichstats === "thingsForPeriod" ? "AMCAdminSideBarSelected" : ""}><a onClick={e => this.show("thingsForPeriod")}>things (30 days)</a></li>
					<li><a onClick={e => this.rebuild("thingsmatrix")}>rebuild things matrix</a></li>
					</ul>
				</div>
			switch (whichstats) {
				case "actions" :
					// body = Object.keys(stats).filter( k => k !== "uri" && !k.startsWith("admin") ).sort().map( key => { return <div className="AMCAdminStats">{key}: {stats[key] || 0}</div> } );
					//break;
					// falls through
				case "things" :
					let date = new Date();
					stats.date = (date.getMonth() + 1) + "/" + date.getDate();
					stats = [ stats ];
					// body = Object.keys(stats).filter( k => k !== "uri" && k !== "kind" && !k.startsWith("owner") ).sort().map( key => { return <div className="AMCAdminStats">{key}: {stats[key] || 0}</div> } );
					//break;
					// falls through
				case "actionsForPeriod" :
					// falls through
				case "thingsForPeriod" :
					let allkeys = {};
					stats.forEach( s => Object.keys(s).forEach( k => allkeys[k] = true ) );
					let KEYS_FILTER = ["uri", "kind", "owner", "updated_at", "created_at", "date"];
					allkeys = Object.keys(allkeys).sort().filter( k => !k.startsWith("admin") && KEYS_FILTER.indexOf(k) === -1 );
					let IMPORTANT_KEYS = ["user", "premium", "pro", "rockstar", "business", "member", "guest"];
					IMPORTANT_KEYS.forEach( key => {
						let index = allkeys.indexOf(key);
						if (index !== -1) {
							allkeys.splice(index, 1);
							allkeys.unshift(key);
						}
					});

					stats.forEach( _stats => { 
						if (_stats.uri.endsWith("nocreationdate")) {
							_stats.date = "0/0";
						} else if (_stats.uri.endsWith("totals")) {
							_stats.date = "totals";
						} else {
							let date = _stats.uri.substring(_stats.uri.indexOf(".") + 1);
							date = ZUtil.getDateFromDayOfYear(parseInt(date.split(".")[1], 10) + 1, parseInt(date.split(".")[0], 10))
							_stats.date = (date.getMonth() + 1) + "/" + date.getDate();
						}
					});
					stats = stats.sort( (a, b) => a.date > b.date ? -1 : 1 );
					//if (whichstats === "thingsForPeriod") {
						//stats.unshift(stats.pop());
						//stats.splice(1, 0, stats.pop());
					//}
					body = stats.map( _stats => {
						return <div key={_stats.date} className="AMCAdminStatsColumn">{[<div key={_stats.date + "header"} className="AMCAdminStatsColumnHeader">{_stats.date}</div>].concat(allkeys.map( key => <div key={_stats.date + "-" + key}>{_stats[key] || 0}</div> ))}</div>;
					});
					width = (12 /*labels */ + 4 /*column width */ * stats.length ) * 1.4 /* font size */;
					// make room for header row
					allkeys.unshift(<div>&nbsp;</div>); 
					body.unshift( <div key="labels" className="AMCAdminStatsColumnLabels">{allkeys.map( key => <div key={key}>{key}</div> )}</div> );
					break;
				default:
					break;
			}
			body =	<div className="AMCAdminBody">
					<div className="AMCAdminBodyScrollable" id="admin-scroller">
						<div style={{width: width + "em"}}>
							{body}
						</div>
					</div>
				</div>
		} else if (view === "settings") {
			sidebar = <div>
					<ul>
					<li><a onClick={e => this.rebuild("core")}>reload ATM core</a></li>
					<li><a onClick={e => this.rebuild("search")}>rebuild search index</a></li>
					<li><a onClick={e => this.rebuild("leaderboards")}>rebuild leaderboards</a></li>
					<li><a onClick={e => this.rebuild("demos")}>rebuild demos</a></li>
					<li><a onClick={e => this.rebuild("sitemap")}>rebuild sitemap</a></li>
					<li><a onClick={e => this.rebuild("fix")}>apply latest fix</a></li>
					<li><a style={{color: "#d00"}} onClick={e => this.rebuild("cache")}>rebuild cache</a></li>
					<li><a style={{color: "#d00", fontWeight: "bold"}} onClick={e => this.rebuild("db")}>rebuild db</a></li>
					</ul>
				</div>
		} else if (view === "cache" || view === "database") {
			sidebar = <div>
					<ul>{tables.map( t => <li key={t} className={t === table ? "AMCAdminTableSelected" : ""} onClick={e => this.onSelectTable(t)}>{t}</li> )}</ul>
					<ul>{this.VIRTUAL_TABLENAMES.map( t => <li key={t} className={t === table ? "AMCAdminTableSelected" : ""} onClick={e => this.onSelectTable(t)}>{t}</li> )}</ul>
				</div>
			let the_header = [];
			let the_table = [];
console.log("sort_colun=" + sort_column + ", sort_order=" + sort_order);
			sort_order = sort_order === "ASC" ? 1 : -1;
			if (table) {
				let props = {};
				items.forEach( item => Object.keys(item).forEach( p => ZUtil.isInteger(p) || item[p] == null ? {} : props[p] = (props[p] || 0) + 1 ) );
				let keys = Object.keys(props);
				keys = keys.sort((a,b) => { return props[b] - props[a] });
//keys.forEach( k => console.log("key=" + k + ",num items with key=" + props[k]) );
//items.forEach( item => console.log("item=" + item.uri + ",keys=" + Object.keys(item)) );;
				let PREFERRED = ["uri", "kind", "owner", "group", "name", "type"];
				keys = ZUtil.uniq([].concat(PREFERRED).concat(keys));
				keys.unshift("#");
//console.log("num keys=" +keys.length);
				the_header = <div className="ACMAdminHeaderHScroller" id="amc-admin-h-scroller"><ul>{ keys.map( (p, index) => <li key={p} id={"admin-th" + index} onClick={this.toggleSortOrderAndColumn.bind(this, p)}>{p}</li> ) }</ul></div>

				if (!this.sorted_items) {
					this.sorted_items = items.filter( (item, row) => typeof item !== "string" ).sort((a,b) => (a[sort_column] || "zzzz") < (b[sort_column] || "zzzz") ? -sort_order : sort_order);
				}
				the_table = <table spacing="0" cellSpacing="0"><tbody>
					{ this.sorted_items.sort((a,b) => (a[sort_column] || "zzzz") < (b[sort_column] || "zzzz") ? -sort_order : sort_order).map( (item, rowindex) => {
						item["#"] = rowindex;
						return <tr key={"#" + rowindex} onClick={this.onSelectItem.bind(this, item)}>{ keys.map( (prop, index) => <td key={"prop:" + prop + rowindex} ><div title={item[prop] + ""} id={rowindex === 0 ? "admin-td" + index : ""}>{typeof item[prop] === "object" ? JSON.stringify(item[prop] || "").replace(/"/g,"") : item[prop]}</div></td> ) }</tr>
					} ) }
				</tbody></table>
			}
			if (items.length === 0) {
				the_table = <div className="CENTERED"><h1>No items found</h1></div>
				the_header = null;
			}
			body = 
				<div className="AMCAdminTable">
					<div className="AMCAdminTableHeader">
						{the_header}
					</div>
					<div className="AMCAdminTableScrollable" onScroll={this.onScroll.bind(this)}>
						{the_table}
					</div>
				</div>
		} else {
			/////////////////////
			// Logs
			/////////////////////
			logs = logs || [];
			ZLog.log("AMCAdmin.logs.length=" + logs.length);
			// ZLog.debug("AMCAdmin.logs=", {logs: logs});
			if (filter) {
				logs = logs.filter( line => line.message.indexOf(filter) !== -1 );
			}
			for (let i = 0; i < logs.length; ++i) {
				if (!logs[i].message) {
					ZLog.error("Invalid log: no message field: ", logs[i]);
					logs.split(i, 1);
					--i;
				}
			}
// ???			logs = logs.filter( line => line.message.indexOf("servicelogs") === -1 );
			let search_results_count = 0;
			let errors_count = 0;
			let payload = logs.map( (line, linenum) => { 
				let log;
				if (typeof line.message !== "string") {
					line = { message: JSON.stringify(line.message) };
				}
				let has_keyword = this.hasKeyword(line.message, search_logs_keyword);
//				errors_count += this.hasKeyword(line.message, "error") ? 1 : 0
				errors_count += line.level === "error" ? 1 : 0
				if (search_logs_keyword && search_logs_keyword.startsWith("level:")) {
					has_keyword = line.level === search_logs_keyword.substring("level:".length);
				}
				if (has_keyword) {
					++search_results_count;
				}
				if (!line.message) {
					ZLog.log("Log line has no message=", { linenum: linenum, prevline: linenum > 0 ? logs[linenum - 1] : "none", line: line });
					line = { message: "bad line" };
				}
				if (line.message.indexOf("\n") !== -1) {
					log = line.message.split("\n").map((str, index) => <div key={index + ":" + linenum} className={"IndentSpaces" + (str.length - str.trim().length)}>{this.replaceKeywordWithEmphasis(str, search_logs_keyword)}</div>)
				} else {
					log = this.replaceKeywordWithEmphasis(line.message, search_logs_keyword);
				}
				return (
					<div key={"console" + linenum} id={has_keyword ? "search-result" + search_results_count : ""} className={"RockInspectorConsoleLine ClearFix " + (line.level === "error" ? " RockInspectorConsoleLineError" : "")}>
						<span className="RealtimeCountdown" data-countdown-zero-hour={line.timestamp}>{ZUtil.toShortDate(line.timestamp || Date.now())}</span>
						{ log }
						<span className="RockInspectorConsoleLineLocation">{line.at}</span>
					</div> 
				)
			});
			this.total_num_search_items = search_results_count;
			sidebar = <ul>{(servicelogs_uris || []).map( u => <li key={u} className={u === servicelog_uri ? "AMCAdminTableSelected" : ""} onClick={e => this.onSelectServiceLog(u)}>{u}</li> )}</ul>
			let the_header = 
				<div className="AMCAdminTopBarLogHeader">
					<div className="AMCAdminTopBarLogHeaderInput">
						<input type="text" onKeyUp={this.onSearchLogsChange} defaultValue={search_logs_keyword} placeholder="Search..." />
					</div>
					<div className="AMCAdminTopBarLogHeaderButtons">
						{ errors_count > 0 ? <span className="AMCAdminTopBarLogHeaderErrors" onClick={e => this.searchLogs("level:error")}>{errors_count} <FontAwesomeIcon icon={faExclamationTriangle} /></span> : '' }
						<span className="AMCButton2" onClick={e => this.onSearchIndexChange(-1)}>back</span>
				 		<span className="AMCAdminTopBarLogHeaderCount">{current_search_item_index} / {search_results_count} </span>
						<span className="AMCButton2" onClick={e => this.onSearchIndexChange(1)}>next</span>
					</div>
				</div>

			body = 
				<div className="AMCAdminBody">
					<div className="AMCAdminTableHeader">
						{the_header}
					</div>
					<div className="AMCAdminBodyScrollable" id="admin-scroller">
						{payload}
					</div>
				</div>
		}
//					<span id="settings" className={"ACMAdminTopBarSettings" + (view === "settings" ? " ACMAdminTopBarSettingsSelected" : "")} onClick={e => this.onSelectView("settings")} > <FontAwesomeIcon icon={faCog} /> </span>
		return (
			<div className="AMCAdmin">
				<div className="AMCAdminTopBar">
					<input type="radio" name="view" id="stats" defaultChecked={view === "stats"} onChange={e => this.onSelectView("stats")} />  <label htmlFor="stats">stats</label>
					<input type="radio" name="view" id="settings" defaultChecked={view === "settings"} onChange={e => this.onSelectView("settings")} />  <label htmlFor="settings">settings</label>
					<input type="radio" name="view" id="database" defaultChecked={view === "database"} onChange={e => this.onSelectView("database")} />  <label htmlFor="database">database</label>
					<input type="radio" name="view" id="cache" defaultChecked={view === "cache"} onChange={e => this.onSelectView("cache")} /> <label htmlFor="cache">cache</label>
					<input type="radio" name="view" id="apilogs" defaultChecked={view === "apilogs"} onChange={e => this.onSelectView("apilogs")} /> <label htmlFor="apilogs">api logs</label>
					<input type="radio" name="view" id="serverlogs" defaultChecked={view === "serverlogs"} onChange={e => this.onSelectView("serverlogs")} /> <label htmlFor="serverlogs">server logs</label>
					<input type="radio" name="view" id="servicelogs" defaultChecked={view === "servicelogs"} onChange={e => this.onSelectView("servicelogs")} /> <label htmlFor="servicelogs">service logs</label>
					<div className="ACMAdminTopBarRightside">
						<input type="radio" name="platform" id="dev" defaultChecked={platform === "dev"} onChange={e => this.onSelectPlatform("dev")} /> <label htmlFor="dev">dev</label>
						<input type="radio" name="platform" id="staging" defaultChecked={platform === "staging"} onChange={e => this.onSelectPlatform("staging")} /> <label htmlFor="staging">staging</label>
						<input type="radio" name="platform" id="production" defaultChecked={platform === "production"} onChange={e => this.onSelectPlatform("production")} /> <label htmlFor="production">production</label>
						<span className="ACMAdminTopBarRefreshButton" onClick={this.refreshScreen}><FontAwesomeIcon icon={faSyncAlt} /></span>
					</div>
				</div>
				<div className="AMCAdminContent">
					<div className="AMCAdminSidebar">
						{sidebar}
					</div>
					{body}
				</div>
			</div>
		)
	}
	componentDidUpdate() {
		let index = 0;
		let col = 0;
		while ((col = document.getElementById("admin-td" + index)) != null) {
			document.getElementById("admin-th" + index).style.left = 
				ZUtil.getBoundingClientRect(col, "grandparent").left + "px";
			++index;
		}
		if (document.getElementById("admin-scroller") && document.getElementById("search-result" + this.state.current_search_item_index)) {
console.log("calling scrollto");
			ZUtil.scrollToTop("search-result" + this.state.current_search_item_index, "admin-scroller");
		}
	}
	updateHeaderLabels(scrollleft) {
		if (document.getElementById("amc-admin-h-scroller")) {
			document.getElementById("amc-admin-h-scroller").style.left = -scrollleft + "px";
		}
	}
}

class AMCAdminItemPopup extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	onChange() {
	}
	render() {
		let { item } = this.props;
		let fields = Object.keys(item).map( k => {
			if (typeof item[k] === "string") {
				return { name: k, field: k, kind: "string", minlen: 1 };
			} else if (typeof item[k] === "number") {
				return { name: k, field: k, kind: "integer", defaultValue: 0 };
			} else {
				return { name: k + "(obj)", field: k, kind: "string", minlen: 1 }
			}
		} );
		let the_item = <AMCForm fields={fields} values={item} onChange={this.onChange.bind(this)} />
		return (
			<div className="AMCAdminItem" onClick={ZUtil.eatEvent}>
				{the_item}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/AMCAdmin.js